import { z } from 'zod';
import { DIFF_SEVERITY, DIFF_TYPE } from '../constnats/diff';

const diffTypeSchema = z.nativeEnum(DIFF_TYPE);
export type DiffTypeType = z.infer<typeof diffTypeSchema>;

const propDiffChangedSchema = z.object({
    referenceVal: z.string(),
    targetVal: z.string(),
    severity: z.nativeEnum(DIFF_SEVERITY),
});
export type PropDiffChangedType = z.infer<typeof propDiffChangedSchema>;

const propDiffUnchangedSchema = z.object({});

const propDiffSchema = z.union([propDiffChangedSchema, propDiffUnchangedSchema]);
export type PropDiffType = z.infer<typeof propDiffSchema>;

const fieldDiffDescriptorSchema = z.object({
    id: z.string(),
    label: z.string(),
});
export type FieldDiffDescriptorType = z.infer<typeof fieldDiffDescriptorSchema>;

const descriptorPairSchema = z.object({
    referenceDescriptor: z.string().nullable(),
    targetDescriptor: z.string().nullable(),
}).refine(
    (pair) => pair.referenceDescriptor !== null || pair.targetDescriptor !== null,
    { message: 'At least one descriptor ID must be present' },
);
export type DescriptorPairType = z.infer<typeof descriptorPairSchema>;

const reportDiffSchema = z.object({
    affectedReportId: z.string(),
    diffType: diffTypeSchema,
    fieldDiffs: z.record(z.string(), z.record(z.string(), propDiffSchema)),
});
export type ReportDiffType = z.infer<typeof reportDiffSchema>;

export const reportsDiffSchema = z.object({
    diffDescriptors: z.array(fieldDiffDescriptorSchema),
    reports: z.array(reportDiffSchema),
});
export type ReportsDiffType = z.infer<typeof reportsDiffSchema>;

const descriptorDiffSchema = z.object({
    descriptorId: z.string(),
    diffType: diffTypeSchema,
    // TODO check if this being optional is intentional, previously it was always present
    diffs: z.record(z.string(), propDiffSchema).optional(),
});
export type DescriptorDiffType = z.infer<typeof descriptorDiffSchema>;

export const schemaDiffSchema = z.object({
    diffs: z.array(descriptorDiffSchema),
});
export type SchemaDiffType = z.infer<typeof schemaDiffSchema>;

export const tableDiffSchema = z.object({
    descriptorPairs: z.array(descriptorPairSchema),
    reportsDiff: reportsDiffSchema,
    schemaDiff: schemaDiffSchema,
});
export type TableDiffType = z.infer<typeof tableDiffSchema>;
